export default "__VITE_PUBLIC_ASSET__aa1bb401__"